$(() => {
  const fte_on_payroll_team = () => {
    const number_of_employees = parseInt($('#number-of-employees').val().replace(',', ''), 10);

    return Math.ceil(number_of_employees / 750);
  };

  const run = () => {
    if ($('#fte-on-payroll-team-overridden').val() === '0') {
      $('#fte-on-payroll-team').val(accounting.formatMoney(fte_on_payroll_team(), '', 0));
    }
  };

  run();

  $('#number-of-employees').blur(() => {
    run();
  });

  $('#fte-on-payroll-team').blur(() => {
    $('#fte-on-payroll-team-overridden').val('1');
  });
});
